<div class="info-games">
  @if(selectedGame){
      <div class="race-details">
        <a class="btn btn-back" routerLink="/list-games">
            <img src="images/svg/arrow-right.svg" alt="">
            {{"bet_action.return" | translate}}
        </a>
        <div class="race-details-content">
          <p class="mb-0">{{raceFullNameFormat}}</p>
          <p class="mb-0">
            @if(raceShortNameFormat){
              {{raceShortNameFormat}}&nbsp;&middot;&nbsp;
            }
            {{race?.type}}&nbsp;&middot;&nbsp;{{raceDistanceStr}}&nbsp;&middot;&nbsp;{{horsesCountString}}&nbsp;&middot;&nbsp;
            @if (racePrice) {
              {{racePrice | currencyFormatter}}&nbsp;&middot;&nbsp;
            }
            {{race?.date | date:"HH'h'mm"}}
          </p>
        </div>
      </div>
      <ul class="nav nav-pills " id="pills-tab" role="tablist">
      @for (game of games; track game.code; let i = $index) {
        <li class="nav-item" role="presentation"
          [class.active]="selectedGame.code === game.code">
          <button
            class="nav-link"
            id="pills-game{{i+1}}-tab"
            data-bs-toggle="pill"
            [attr.data-bs-target]="'#pills-game' + (i+1)"
            type="button"
            role="tab"
            aria-controls="pills-game"
            [attr.aria-selected]="selectedGame.code === game.code"
            (click)="selectedGame.code === game.code ? $event.stopPropagation() : changeGame(i)">

            <img
              [src]=" (game.spot.enabled ? 'images/png/spot-games/' : 'images/png/games/') + game.code + '.png'"
              [alt]=" (game.spot.enabled ? 'SPOT ' : '') + game.name">
        </button>
        </li>

      }
      </ul>
      <div class="tab-content" id="pills-tabContent">
          <div class="tab-pane fade" [ngClass]="{'show active': selectedGame.code}" id="pills-game" role="tabpanel" aria-labelledby="pills-game-tab">
            <div class="panel-container">
              <div class="panel-title">
                <span>{{stepNumber}}</span>
                <p>{{'select.formula' | translate}}</p>
              </div>
                @if (gameHasMulti) {
                  <div class="multi-values btn-group btn-group-toggle" >
                    @for (horse of gameMultiPartants; track $index; let l = $index) {
                      <label class="btn btn-secondary btn-multi">
                        <input type="radio" name="game-multi" id="multiHorse{{l}}"
                          [checked]="selectedPartantNo === horse" [disabled]="selectedPartantNo === horse"
                          (change)="selectMultiPartant(horse)">
                        <span>{{horse}}</span>
                      </label>
                    }

                  </div>
              }
            </div>
            <div class="game-type-group">
              <div class="game-type">
                  <div class="btn-group btn-group-toggle" data-toggle="buttons">
                    @if (selectedGame.spot && selectedGame.spot.enabled) {
                      @if (isSpot) {
                        @for (formula of selectedGame.spot.formulas; track $index; let k = $index) {
                          <label class="btn btn-secondary btn-radio SPOT-ON">
                            <input type="radio" name="options-spot-game" id="spot-{{selectedGame.name}}-option-{{k+1}}" [checked]="gameFormula === formula" [disabled]="gameFormula === formula" (change)="changeFormula(formula)">
                            <span>{{('formula.' + formula) | translate}}</span>
                          </label>
                        }
                      } @else {
                        @for (formula of selectedGame.formulas; track $index; let k = $index) {
                          <label class="btn btn-secondary btn-radio">
                            <input type="radio" name="options-game" id="{{selectedGame.name}}-option-{{k+1}}"
                              [checked]="gameFormula === formula" [disabled]="gameFormula === formula"
                              (change)="changeFormula(formula)">
                            <span>{{('formula.' + formula) | translate}}</span>
                          </label>
                        }
                      }
                    } @else {
                      @for (formula of selectedGame.formulas; track $index; let k = $index) {
                        <label class="btn btn-secondary btn-radio">
                          <input type="radio" name="options-game" id="{{selectedGame.name}}-option-{{k+1}}" [checked]="gameFormula === formula" (change)="changeFormula(formula)" [disabled]="gameFormula === formula">
                          <span>{{('formula.' + formula) | translate}}</span>
                        </label>
                      }
                    }
                  </div>
                  @if (selectedGame.spot && selectedGame.spot.enabled) {
                    <div class="btn-group btn-group-toggle" data-toggle="buttons">

                   <label class="btn btn-secondary btn-radio SPOT">
                        <input type="checkbox" name="spot" id="{{selectedGame.name}}-option-{{selectedGame.formulas.length + 1}}" [checked]="isSpot" (change)="toggleSpot()">
                        <img
                          src="images/png/spot.png"
                          [alt]="'Spot' | translate" />
                      </label>
                    </div>
                  }
              </div>
            </div>
        </div>

      </div>
  }
</div>

